import { useForm } from "react-hook-form";
import { useMutation } from "react-query";
import { api } from "utils/api";

type NewsletterFields = { email: string };

const postSubscribeWeeklyHugs = ({ email }: NewsletterFields) =>
  api.post("/newsletters", {
    body: JSON.stringify({ email, weeklyHug: true }),
  });

const useSubscribeWeeklyHugsForm = () => {
  const { handleSubmit, ...form } = useForm<NewsletterFields>();
  const mutation = useMutation(postSubscribeWeeklyHugs);
  const onSubmit = handleSubmit((formData) => {
    mutation.mutate(formData);
  });

  return { onSubmit, mutation, ...form };
};

export { useSubscribeWeeklyHugsForm };
